"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const config_1 = require("config");
const ErrorBoundary_1 = require("./components/common/ErrorBoundary");
const RootView_1 = require("./components/join-launcher/RootView");
const CoreContext_1 = require("./contexts/CoreContext");
const UserContext_1 = require("./contexts/UserContext");
const ObjectHelper_1 = require("./helpers/ObjectHelper");
const PromisesHelper_1 = require("./helpers/PromisesHelper");
const EcsConfig_1 = require("./models/EcsConfig");
const Environment_1 = require("./models/Environment");
const JoinInfo_1 = require("./models/JoinInfo");
const BootstrapService_1 = require("./services/BootstrapService");
const EcsClient_1 = require("./services/EcsClient");
const EnvironmentService_1 = require("./services/EnvironmentService");
const FeaturesService_1 = require("./services/FeaturesService");
const LauncherService_1 = require("./services/LauncherService");
const TranslationService_1 = require("./services/TranslationService");
const RootView_2 = require("./components/join-launcher/RootView");
class AppBootstrapper {
    constructor() {
        this.bootstrap = () => {
            this.flags = FeaturesService_1.default.getFeatureFlags();
            const bootstrapService = new BootstrapService_1.BootstrapService(this.flags);
            this.joinInfo = bootstrapService.getJoinInfo();
            this.userContext = bootstrapService.userInfo;
            this.environment = EnvironmentService_1.default.getEnvironmentInfo();
            this.launcherService = new LauncherService_1.LauncherService(this.environment, this.flags, this.joinInfo);
            const meetingTypes = [JoinInfo_1.JoinType.Meetup, JoinInfo_1.JoinType.MeetupWithCode];
            const isMeetupLink = meetingTypes.indexOf(this.joinInfo.type) > -1
                && !(this.joinInfo.meetingInfo
                    && this.joinInfo.meetingInfo.isBroadcast);
            const isFremiumMeetingsLink = bootstrapService.type === JoinInfo_1.JoinType.FremiumMeeting;
            this.meetingV2UI = this.flags.enableUIv2
                && isMeetupLink
                && this.environment.deviceType === Environment_1.DeviceTypes.Desktop;
            this.fremiumMeetingsUI = this.flags.enableFreemiumMeetings
                && isFremiumMeetingsLink
                && this.environment.deviceType === Environment_1.DeviceTypes.Desktop;
            this.shareEmailUI =
                this.flags.enableShareEmailUI &&
                    bootstrapService.type === JoinInfo_1.JoinType.ShareEmail &&
                    this.environment.deviceType === Environment_1.DeviceTypes.Desktop;
            this.mobileMeetingV2UI = this.flags.enableMobileUIv2
                && (isMeetupLink || this.joinInfo.isTflLink)
                && this.environment.deviceType !== Environment_1.DeviceTypes.Desktop;
            if (this.flags.enableExperiment) {
                return PromisesHelper_1.default.timeout(EcsClient_1.default.getConfig(config_1.default.ecs), config_1.default.ecs.timeout)
                    .then(this.render)
                    .catch(this.render);
            }
            if (this.meetingV2UI ||
                this.mobileMeetingV2UI ||
                this.fremiumMeetingsUI ||
                this.shareEmailUI) {
                this.setupV2UI();
            }
            return PromisesHelper_1.default.resolved(this.render());
        };
        this.render = (ecsConfig) => {
            const language = this.getLanguage();
            const languageBundle = I18NBUNDLE;
            TranslationService_1.default.init(languageBundle, language);
            const isModernView = this.meetingV2UI || this.mobileMeetingV2UI || this.fremiumMeetingsUI || this.shareEmailUI;
            const modernViewType = this.getModernViewType();
            return (React.createElement(CoreContext_1.CoreContextProvider, { value: {
                    ecsConfig: ObjectHelper_1.default.mergeObjects({}, EcsConfig_1.defaultEcsConfig, ecsConfig),
                    environment: this.environment,
                    featureFlags: this.flags,
                    language,
                    languageBundle,
                    isModernView,
                    modernViewType,
                    launcherService: this.launcherService,
                    mobileMeetingV2UI: this.mobileMeetingV2UI
                } },
                React.createElement(ErrorBoundary_1.ErrorBoundary, null,
                    React.createElement(UserContext_1.UserContextProvider, { value: this.userContext },
                        React.createElement(RootView_1.RootView, { featureFlags: this.flags, joinInfo: this.joinInfo })))));
        };
        this.getLanguage = () => {
            return (document.getElementsByTagName("html")[0].getAttribute("lang") ||
                "en-us");
        };
    }
    setupV2UI() {
        const className = " uiv2";
        const htmlElm = self.document.getElementsByTagName("html")[0];
        if (htmlElm) {
            htmlElm.className += className;
        }
        if (this.environment.browserName === Environment_1.Browsers.Edge) {
            htmlElm.className += " edge";
        }
    }
    getModernViewType() {
        if (this.mobileMeetingV2UI) {
            return RootView_2.ModernViewType.MobileMeeting;
        }
        if (this.meetingV2UI) {
            return RootView_2.ModernViewType.Meeting;
        }
        if (this.fremiumMeetingsUI) {
            return RootView_2.ModernViewType.FreemiumOnboarding;
        }
        if (this.shareEmailUI) {
            return RootView_2.ModernViewType.ShareEmail;
        }
        return RootView_2.ModernViewType.None;
    }
}
exports.default = AppBootstrapper;
